// extracted by mini-css-extract-plugin
export var aboveInput = "_n4-0";
export var actionButton = "_n4-5";
export var actionButtonContainer = "_n4-1";
export var actionIcon = "_n4-6";
export var aiInfoContainer = "_n4-2";
export var attachmentWrapper = "_n4-7";
export var bold = "_n4-3";
export var checkIcon = "_n4-8";
export var clickingRecipientBar = "_n4-11";
export var commentThreadSwitch = "_n4-a";
export var draftImage = "_n4-b";
export var draftImageContainer = "_n4-c";
export var draftImages = "_n4-e";
export var editButton = "_n4-g";
export var editor = "_n4-f";
export var editorContainer = "_n4-y";
export var editorErrorTooltipWrapper = "_n4-9";
export var headerDivider = "_n4-h";
export var icon = "_n4-i";
export var info = "_n4-j";
export var internal = "_n4-n";
export var internalDivider = "_n4-k";
export var internalMessage = "_n4-l";
export var messageInputCard = "_n4-m";
export var messageInputForm = "_n4-o";
export var messageInputFormInternal = "_n4-p";
export var options = "_n4-q";
export var publicMessageCustomer = "_n4-s";
export var publicMessageMerchant = "_n4-r";
export var removeImageButton = "_n4-d";
export var replyButtons = "_n4-t";
export var showSignatureButton = "_n4-u";
export var spinner = "_n4-v";
export var verticalButtonDivider = "_n4-4";
export var visibilitySelector = "_n4-w";
export var warning = "_n4-x";
export var wrappingText = "_n4-z";
export var writingInternalNoteTopBorder = "_n4-10";